import { motion } from "framer-motion";

export default function NotificationBar() {
  return (
    <div className="relative w-full overflow-hidden">
      <div className="absolute inset-0 bg-[#020617]" />

      <div className="absolute inset-0 bg-gradient-to-br from-indigo-900/35 via-black to-cyan-900/25" />

      <div className="absolute left-0 top-0 h-full w-1/3 bg-gradient-to-r from-indigo-900/40 to-transparent" />
      <div className="absolute right-0 top-0 h-full w-1/3 bg-gradient-to-l from-cyan-900/35 to-transparent" />

      <div className="relative h-10 flex items-center border-b border-white/10">
        <motion.div
          className="
            absolute
            flex items-center gap-3 whitespace-nowrap
            text-sm
            text-gray-200 tracking-wide
          "
          initial={{ x: "100%" }}
          animate={{ x: "-100%" }}
          transition={{
            repeat: Infinity,
            duration: 30,
            ease: "linear",
          }}
        >
          <span
            className="
            px-2.5 py-0.5 rounded-md text-xs font-bold uppercase
            bg-gradient-to-r from-indigo-500 via-purple-500 to-cyan-500
            text-white shadow-lg
            tracking-wider
          "
          >
            New
          </span>

          <span className="font-medium">
            Internships available on the topics listed on our website — Enroll Now
          </span>
        </motion.div>
      </div>
    </div>
  );
}
